import { render } from "./owner-welcome.vue?vue&type=template&id=17c92c2a"
import script from "./owner-welcome.js?vue&type=script&lang=js"
export * from "./owner-welcome.js?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__